import {useLocation} from "react-router-dom-v5-compat";

import {useParams} from "./use-params.ts";

/**
 * Get the route path of the current route.
 *
 * This is a version of useRouteMatch that works with v5 and v6, based upon
 * the StackOverflow answer here: https://stackoverflow.com/a/70754791
 *
 * There are definitely conditions in which this wouldn't work correctly,
 * especially if there are multiple params with the same value.
 *
 * @returns The route path of the current route.
 */
export const useRoutePath = (): string => {
    const params = useParams();
    const {pathname} = useLocation();
    let match = pathname;

    Object.entries(params).forEach(([paramName, paramValue]) => {
        if (paramValue && paramName !== "*") {
            match = match.replace(`/${paramValue}`, `/:${paramName}`);
        }
    });

    return match;
};
